import { Box, ColorOptions, Loader, Spacer, Text } from '@jfs/ui-new'
import { useEffect, useState } from 'react'
import { Dropdown } from '../../components/Dropdown'
import { List } from '../../components/List'
import PaginationController from '../../components/PaginationController/PaginationController'
import { useLazyApiData, useStores } from '../../data/store'
import { pageSizeList, posApprovedHeadTitles } from '../../utils/constants'

const ApprovedPos = () => {
  const {
    getApprovals,
    fetchPendingApprovals,
    paginationData,
    updatePagination,
    pagenumber,
    updatePageSize,
    pageSize,
  } = useStores((store) => ({
    getApprovals: store.posApprovals.getApprovals,
    fetchPendingApprovals: store?.posApprovals?.fetchPendingApprovals,
    paginationData: store?.posApprovals?.pagination,
    pagenumber: store?.posApprovals?.pagination?.number,
    pageSize: store?.posApprovals?.pagination?.size,
    updatePagination: store?.posApprovals?.updatePagination,
    updatePageSize: store?.posApprovals?.updatePageSize,
  }))
  const [sortOrder, setSortOrder] = useState([])

  const listData = getApprovals()
  const [lazyFetchApi, { state: fetchApiState }] = useLazyApiData(fetchPendingApprovals)

  useEffect(() => {
    lazyFetchApi('APPROVED', sortOrder)
  }, [pagenumber, pageSize, sortOrder])

  const onPageSizeSelect = (pageSize: number) => {
    updatePagination(0)
    updatePageSize(pageSize)
  }

  const onSortPress = (key: any) => {
    const keyValueMap = {
      id: 'id',
      createdAt: 'createdAt',
      eccCreatedAt: 'eccCreatedAt',
    }
    if (!!keyValueMap[key]) {
      const keyValue = keyValueMap[key]
      const keyExists = sortOrder?.find((item) => item?.[0] === keyValue)
      if (keyExists) {
        const updatedOrder = sortOrder?.map((item) => {
          if (item?.[0] === key) {
            return [keyValue, item?.[1] === 'asc' ? 'desc' : 'asc']
          } else {
            return item
          }
        })
        setSortOrder(updatedOrder)
      } else {
        setSortOrder([...sortOrder, [keyValue, 'asc']])
      }
    }
  }

  return (
    <Box>
      <Text title={'View Approved POS'} fontSize={28} fontWeight={'600'} color={'#5a5c69' as ColorOptions} />
      <Spacer direction="vertical" size={24} />
      {fetchApiState === 'pending' && <Loader />}
      <Box flexDirection={'row'} justify={'flex-end'}>
        <Box flexDirection={'row'} align={'center'}>
          <Text title={'Rows per page: '} fontFamily={'jiotype-medium'} fontSize={14} color={'PRIMARY_GREY'} />
          <Dropdown data={pageSizeList} selectedData={onPageSizeSelect} value={'' + pageSize} />
        </Box>
        <Spacer direction="horizontal" size={8} />
        <PaginationController
          currentPage={paginationData?.number ?? 0}
          totalPages={paginationData?.totalPages ?? 0}
          totalDataLength={paginationData?.totalElements ?? 0}
          dataSetSize={paginationData?.size ?? 0}
          onSelect={updatePagination}
          isZeroIndex={true}
          defaultPage={0}
        />
      </Box>
      <Spacer direction="vertical" size={8} />
      {fetchApiState !== 'pending' && (
        <List
          keyExtractor={(item: any) => item.id}
          headTitle={posApprovedHeadTitles}
          numOfColumns={9}
          sizeConfig={[0.3, 0.5, 0.5, 0.8, 0.5, 0.5, 0.5, 0.5, 0.5]}
          data={listData?.slice()}
          listTitle={''}
          isColumnSearchEnabled={false}
          hidePagination={true}
          pageSizeFromApi={pageSize}
          updateSortKeys={onSortPress}
          sortOrder={sortOrder}
        />
      )}
    </Box>
  )
}

export default ApprovedPos
